import { Iheure } from '../static-client/static-client.i';

export abstract class AStatic {
  dataApp!: IDataApp;
  marge!: number;
  nbSession!: INbSession[];
  totalJour!: ITotalJour[];
  pourcentCA!: number;
  totalHeureBPF!: Iheure[];
  totalHeure!: Iheure[];
}

export abstract class AStatistiqueCardVisualisation {
  ca?: boolean;
  marge?: boolean;
  session?: boolean;
  stagiare?: boolean;
  satisfaction?: boolean;
}

export interface IStatistiqueCardVisualisationInter extends AStatistiqueCardVisualisation {
  produit_encadre?: boolean;
  cout_intervenant?: boolean;
  indisponibilite?: boolean;
  deplacement?: boolean;
}

export abstract class AStaticRequest {
  listeSessionStatut?: number[];
  dateDebutPeriode?: string;
  dateFinPeriode?: string;
  listeProduit?: string[];
  listeProduitSecteur?: string[];
  listeProduitGroupe?: string[];
  listeProduitFamille?: string[];
  listResponsableAdministratif?: string[];
}

export interface IStaticInterInfo extends AStatic {
  ca?: ICa;
  coutTotalInterv?: number;
  indispoInterv?: IIndispoInterv[];
  infoCoutTotalInterv?: IInfoCoutTotalInterv[];
  produitsEncadres?: IProduitsEncadres[];
  satisfaction?: ISatisfaction[];
  trajetInterv?: ITrajetInterv[];
}

export interface ICa {
  prixGlobal: number;
  prixRessource: number;
}

export interface IDataApp {
  nbApp: number;
  taux: number;
}

export interface IIndispoInterv {
  date_debut: string;
  date_fin: string;
  libelle: string;
}

export interface IInfoCoutTotalInterv {
  cout_deplacement: number;
  cout_hotel: number;
  cout_materiel: string;
  cout_pedagogique: number;
  cout_repas: number;
  id: number;
}

export interface INbSession {
  coalesce: string;
}

export interface IProduitsEncadres {
  nb_produits: string;
}
export interface ISatisfaction {
  satisfaction: number;
}

export interface ITotalJour {
  jour: number;
}

export interface ITrajetInterv {
  distance_totale: number;
  id: number;
  temps_de_trajet: number;
}

export interface IStaticInterRequest extends AStaticRequest {
  idIntervenant: number;
}
